<template>
	<div style="height:100%">
		<el-header style="width:100%;height:100%;background-color:#ffffff;padding:0">
			<div style="width:100%;height:100%;float:feft" class="header">
				<ul style="width:10%;height:100%;text-align:center;min-width:180px;max-width:185px"><img
						src="../../assets/logo.png" style="border-radius:0" class="imgStyles"></ul>
				<ul class="shaYu">纬普全域智慧导览</ul>
				<ul class="houTai">后台管理系统</ul>
				<ul class="goout" style="float:right;margin:0 20px 0 0"><img src="../../assets/关机.png" style="cursor:pointer" class="imgStyle" @click="goOut()"></ul>
			</div>
		</el-header>
	</div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";
import {mapState} from "vuex";

export default {
	data() {
		return {
			photoInfo: '',
			teacherName: '',
			score: '',
			fatherSerial: '',
		}
	},
	mounted() {
		var userData = qs.parse(sessionStorage.getItem("userData"));
		this.score = userData.score
		this.photoInfo = userData.headimgurl
		this.teacherName = userData.teacher_name
		this.fatherSerial = userData.father_serial
	},
	methods: {
		//退出
		goOut() {
			var that = this
			that.$router.push({path: "./"});
		}
	}
}
</script>

<style scoped>
.goout {
	position: relative;
	top: 50%;

	transform: translateY(-50%);
}

@media (min-width: 992px) {
	.imgStyle {
		width: 20px;
		height: 20px;
		border-radius: 50%

	}

	.imgStyles {
		width: auto;
		height: 100%;


	}

}

@media (min-width: 1200px) {
	.imgStyle {
		width: 30px;
		height: 30px;
		border-radius: 50%


	}

	.imgStyles {
		width: auto;
		height: 100%;


	}
}

@media (min-width: 1920px) {
	.imgStyle {
		width: 50px;
		height: 50px;
		border-radius: 50%;


	}

	.imgStyles {
		width: auto;
		height: 100%;


	}
}

/* 图片样式 */

/* 鲨鱼学校文字样式 */
.shaYu {
	width: 240px;
	font-size: 28px;
	font-weight: bold;
	position: relative;
	top: 47%;

	transform: translateY(-50%);

}

/* 页头样式 */
.header ul {
	float: left;

}

/* 后台管理系统文字样式 */
.houTai {
	position: relative;
	top: 50%;

	transform: translateY(-50%);

	font-size: 18px;
	color: #7a7d7a;
	width: 109px;
	text-align: center;
}

.lingDang {
	position: relative;
	top: 50%;
	transform: translateY(-50%);
	margin-left: 52px
}

@media screen and (max-width: 1200px) {
	.youShen img {

		height: 100%;
		width: 60px
	}
}

.youShen {
	position: relative;
	top: 50%;
	transform: translateY(-50%);
	margin-left: 65px;
	margin-right: 15px;
	height: 100%;

}

.wenHao {
	position: relative;
	top: 50%;
	transform: translateY(-50%);
	margin-left: 52px

}

/**/
.messageInfo {
	font-size: 16px;
	width: 340px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	overflow: hidden;

}
</style>




// WEBPACK FOOTER //
// src/components/headerMenuLogin/pageHeader.vue